import Store from "@/models/storePanel/Store.js";
import profile from "./settings/profile";
import products from "./products";
import externalLinks from "./externalLinks";
import coupons from "./coupons";
import settings from "./settings";

class Weekday {
    constructor(weekday = {}) {
        this.open = false;
        if (weekday.day === 0) this.day = 0;
        else this.day = weekday.day || null;
        this.type = weekday.type || "";
        if (weekday.type === "regular") {
            weekday.shifts.push([]);
            this.shifts = weekday.shifts;
        } else {
            this.shifts = weekday.shifts || [[], []];
        }
    }
}

export default {
    namespaced: true,

    modules: {
        profile,
        products,
        externalLinks,
        coupons,
        settings,
    },

    state: () => ({
        loading: false,
        redemptionDialog: false,
        redemptions: [],
        store: new Store(),
        storePermissions: {},
        store_id: null,
        paymentError: false,
        statistics: {},
        paymentsLevel: 4,
        company:{}
    }),

    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },

        setStoreId(state, payload) {
            state.store_id = payload;
        },

        setCompany(state, payload) {
            state.company = payload;
        },

        setStorePermissions(state, payload) {
            state.storePermissions = payload;
        },

        setRedemptionDialog(state, payload) {
            state.redemptionDialog = payload;
        },

        addRedemption(state, payload) {
            state.redemptions.push(payload);
        },

        removeRedemption(state, voucher) {
            state.redemptions = state.redemptions.filter(
                r => r.voucher !== voucher
            );
        },

        setStatistics(state, payload){
            state.statistics = payload;
        },

        setStore(state, payload) {
            if(payload.timetable){
                payload.timetable = payload.timetable.map(day => new Weekday(day));
            }
            state.store = payload;
        },

        setLogo(state, payload) {
            state.store.logo = payload;
        },

        setOfflineMapLogo(state, payload) {
            state.store.offline_map_logo = payload;
        },

        setMapLogo(state, payload) {
            state.store.map_logo = payload;
        },

        setBusinessInformation(state, payload) {
            state.store.name = payload.name;
            state.store.address = payload.address;
            state.zip = payload.zip;
            state.lat = payload.lat;
            state.lon = payload.lon;
            state.store.billing_details.activity = payload.activity;
            state.store.country.country_id = payload.country_id;
            state.store.primary_phone = payload.primary_phone;
            state.store.secondary_phone = payload.secondary_phone;
            state.store.billing_details.mobile = payload.mobile;
            state.store.billing_details.full_name = payload.full_name;
            state.store.email = payload.email;
        },

        setTimetable(state, payload) {
            payload = payload.map(day => new Weekday(day));
            state.store.timetable = payload;
        },

        setInvoicing(state, payload) {
            state.store.billing_details.comp_name = payload.comp_name;
            state.store.billing_details.vat_number = payload.vat_number;
            state.store.billing_details.city = payload.city;
            state.store.billing_details.occupation = payload.occupation;
            state.store.billing_details.tax_office = payload.tax_office;
            state.store.billing_details.country_id = payload.country_id;
        },

        setFastPayment(state, payload) {
            state.store.flags.app_settings.fast_payment = payload;
        },
        setThermalPrinter(state, payload) {
            state.store.flags.reward.thermal_printer = payload;
        },

        setShoppingCart(state, payload) {
            state.store.shopping_cart = payload;
        },

        setRedemption(state, payload) {
            state.store.redemption_type_id = payload;
        },

        setDeliverySettings(state, payload) {
            state.store.delivery_settings = payload;
        },

        setSendPointsActivator(state, payload) {
            state.store.flags.reward.offline_transaction = payload;
        },

        setSendPoints(state, payload) {
            state.store.notify_customers.system_notification_id =
                payload.system_notification_id;
            state.store.flags.reward.offline_transaction_products =
                payload.offline_transaction_products;
            state.store.flags.reward.offline_transaction_receipt =
                payload.offline_transaction_receipt;
            state.store.flags.reward.offline_transaction_receipt_scan =
                payload.offline_transaction_receipt_scan;
            state.store.flags.reward.offline_two_factor_authentication =
                payload.offline_two_factor_authentication;
        },

        setPointDeliveryActivator(state, payload) {
            state.store.flags.reward.pos_points_delivery = payload;
        },

        setPointDelivery(state, payload) {
            state.store.flags.reward.pos_display_amount =
                payload.pos_display_amount;
            state.store.flags.reward.pos_goal_shopping =
                payload.pos_goal_shopping;
        },

        setMobilePayments(state, payload) {
            state.store.flags.reward.online_payment_processing = payload;
        },

        setScanReceiptActivator(state, payload) {
            state.store.flags.reward.open_receipt = payload;
        },

        setScanReceipt(state, payload) {
            state.store.billing_details.receipt_phone = payload.receipt_phone;
            state.store.billing_details.receipt_vat_number =
                payload.receipt_vat_number;
            state.store.billing_details.receipt_address =
                payload.receipt_address;
            state.store.billing_details.receipt_comp_name =
                payload.receipt_comp_name;
        },

        setRewardWithPresence(state, payload) {
            state.store.flags.reward.open_checkin = payload;
        },

        setOrders(state, payload) {
            state.store.flags.reward.orders_allowed = payload;
        },

        setPaymentError(state, payload){
            state.paymentError = payload;
        },

        setPaymentsLevel(state, payload) {
            state.paymentsLevel = payload;
        }
    },

    actions: {
        async getStore({ commit, state }) {
            try {
                commit("setLoading", true);

                const { data } = await Store.get();

                localStorage.setItem("companyId", data.data.company.store_id);
                commit("setStore", data.data);
                commit("setStore", data.data, { root: true });
                // commit("setStorePermissions",data.data.permissions)
                commit("setStoreId",data.data.store_id)
                commit("setPaymentError", false);

                // const companyData = await Store.getCompany();
                commit("setCompany", data.data.company);

                commit("setLoading", false);

            } catch (ex) {
                if(ex.response.data.code == 301){
                    commit("setStore", ex.response.data.data);
                    // state.store.logo = ex.response.data.data.logo
                    commit("setPaymentError", true);
                    // commit("setStorePermissions",[])
                }
                commit("setLoading", false);
                console.error(ex.response.data.message);
            }
        },

        async getStatistics({ commit }) {
            try {
                commit("setLoading", true);
                const { data } = await Store.getStatistics();

                commit("setStatistics", data.data.statistics);
                
                commit("setLoading", false);
            } catch (ex) {
                commit("setLoading", false);
                console.error(ex.response.data.message);
            }
        },

        async rejectRedemption({ commit }, item) {
            try {
                item.rejectLoading = true;

                await Store.rejectRedemption({
                    voucher: item.voucher
                });

                item.rejectLoading = false;
                commit("removeRedemption", item.voucher);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully rejected voucher!"
                    },

                    { root: true }
                );
            } catch (ex) {
                item.rejectLoading = false;
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async acceptRedemption({ commit }, item) {
            try {
                item.acceptLoading = true;

                await Store.acceptRedemption({
                    voucher: item.voucher
                });

                item.acceptLoading = false;
                commit("removeRedemption", item.voucher);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully accepted voucher!"
                    },

                    { root: true }
                );
            } catch (ex) {
                item.acceptLoading = false;
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async getPandingPayments({ commit, state }) {
            try {
                const { data } = await Store.getPandingPayments();
                if(data.data.pending_payments){
                    const paymentsLevel = data.data.level === "level-1" ? 1 :
                    data.data.level === "level-2" ? 2 : 3
                    commit("setPaymentsLevel", paymentsLevel)
                }else {
                    commit("setPaymentsLevel", 4)
                }
            } catch (ex) {
                console.error(ex.response.data.message);
            }
        },
    }
};
